module.exports = __webpack_public_path__ + "static/media/bg.518d49e3.jpg";